import { Stack, Typography } from '@mui/material';
import { MultiSelectFilter } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';
import { DiscountGroup } from '@retail/products/types';

interface Props<K extends string | number> {
  discountGroups: DiscountGroup[];
  selectedDiscountGroups: K[];
  getDiscountGroupKey: (discountGroup: DiscountGroup) => K;
  selectDiscountGroups: (keys: K[]) => void;
  disabled?: boolean;
  disabledReason?: string;
  isLoading?: boolean;
}

export function SelectDiscountGroups<K extends string | number>({
  discountGroups,
  selectedDiscountGroups,
  getDiscountGroupKey,
  selectDiscountGroups,
  disabled,
  disabledReason,
  isLoading,
}: Props<K>) {
  const t = useProductsTFunction();

  return (
    <MultiSelectFilter
      label={t('products.search.discountGroup.label')}
      placeholder={t('products.search.discountGroup.searchInDiscountGroup')}
      options={discountGroups}
      value={discountGroups.filter((discountGroup) =>
        selectedDiscountGroups.includes(getDiscountGroupKey(discountGroup))
      )}
      onChange={(selected) => selectDiscountGroups(selected.map(getDiscountGroupKey))}
      disabled={disabled}
      disabledReason={disabledReason}
      isLoading={isLoading}
      dividers
      getOptionKey={getDiscountGroupKey}
      getOptionLabel={({ name, code }) => (name ? `${code} ${name}` : code)}
      getChipLabel={({ name, code }) => name || code}
      renderOptionContent={({ name, code }) => (
        <Stack flexDirection="row" gap={1}>
          <Typography variant="body2">{code}</Typography>
          <Typography variant="body2">{name}</Typography>
        </Stack>
      )}
    />
  );
}
